module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(5)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "section intro"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-5 white text-sm-left"
  }, [_c('h1', {
    staticClass: "m-t-0 m-b-lg"
  }, [_vm._v("The LogBox Story")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "section section-a"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6 col-md-offset-3 text-left"
  }, [_c('h1', {
    staticClass: "m-b-lg"
  }, [_vm._v("In the beginning")]), _vm._v(" "), _c('div', [_c('p', {
    staticClass: "lead"
  }, [_vm._v("LogBox was founded in 2010 by an orthopaedic surgeon who wanted to change the way things were done. ")]), _vm._v(" "), _c('p', [_vm._v("LogBox simplifies everybody’s life – from the "), _c('a', {
    attrs: {
      "href": "#/patient"
    }
  }, [_vm._v("patient")]), _vm._v(" to the "), _c('a', {
    attrs: {
      "href": "#/practice"
    }
  }, [_vm._v("healthcare professional ")]), _vm._v(" to the "), _c('a', {
    attrs: {
      "href": "#/academic"
    }
  }, [_vm._v("trainee doctor")]), _vm._v(".\n\t\t\t\t\tAdmin is a part of life, but it doesn’t add any value, only plenty of time and frustration. LogBox was designed by doctors who understand the value of people\n\t\t\t\t\tand their time, and who understand the needs of healthcare professionals, the healthcare industry and their patients.")]), _vm._v(" "), _c('p', [_vm._v("LogBox improves the connections between people and healthcare professionals and is part of our commitment to creating user-friendly and intelligent clinical\n\t\t\t\t\t\tsolutions which leverage modern technology to inspire collaboration and transformation. ")])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "section section-b"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6 col-md-offset-3 text-left"
  }, [_c('h1', {
    staticClass: "m-b-lg"
  }, [_vm._v("A good start")]), _vm._v(" "), _c('div', [_c('p', [_vm._v("Even before its official launch, LogBox was piloted at the Wits Donald Gordon Medical Centre and registered more than 5,000 patients.\n\t\t\t\t\t\tIt was also nominated as a finalist in the MTN Business App of the Year Awards when it was only three months old. ")])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "section section-c"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6 col-md-offset-3 text-left"
  }, [_c('h1', {
    staticClass: "m-b-lg"
  }, [_vm._v("Big brother")]), _vm._v(" "), _c('div', [_c('p', {
    staticClass: "lead"
  }, [_vm._v("EPI-USE is a company founded in South Africa with offices in 22 countries.")]), _vm._v(" "), _c('p', [_vm._v("The company has been building a successful track record in bespoke\n\t\t\t\t\t\t\tsoftware application development since its inception in 1984 and has been involved in a large number of successful, custom software engineering\n\t\t\t\t\t\t\tprojects ever since, spanning industries like Telecommunications, Energy, Insurance, Mining, Oil & Gas, Government, Insurance, Education, and\n\t\t\t\t\t\t\tHealthcare; in both local and international markets. EPI-USE's software application development capability is traded under the 'Advance' brand.")]), _vm._v(" "), _c('p', [_vm._v("More information can be found at "), _c('a', {
    attrs: {
      "href": "http://www.advance.io"
    }
  }, [_vm._v("www.advance.io")]), _vm._v(".")])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "section section-d"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6 col-md-offset-3 text-left"
  }, [_c('h1', {
    staticClass: "m-b-lg"
  }, [_vm._v("A secure solution")]), _vm._v(" "), _c('div', [_c('p', {
    staticClass: "lead"
  }, [_vm._v("Privacy and security is at the heart of the LogBox products, which is why we take every precaution to secure and protect the personal and health information of each patient.")]), _vm._v(" "), _c('p', [_vm._v("Security concerns are addressed on every level from application infrastructure and authentication to data encryption. Your information is not shared with anyone without your consent.")]), _vm._v(" "), _c('p', [_vm._v("LogBox is Protection of Personal Information (POPI) compliant.")])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "about-landing"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('section', {}, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row flush"
  }, [_c('div', {
    staticClass: "col-md-4 grey-1"
  }, [_c('div', {
    staticClass: "p-a-lg"
  }, [_c('h3', {
    staticClass: "m-t-0 m-b"
  }, [_vm._v("LogBox Patient")]), _vm._v(" "), _c('p', {}, [_vm._v("LogBox allows you to share your information with your healthcare professional securely. No more paper forms needed.")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-default",
    attrs: {
      "to": "/patient"
    }
  }, [_vm._v("Learn More")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 grey-2"
  }, [_c('div', {
    staticClass: "p-a-lg"
  }, [_c('h3', {
    staticClass: "m-t-0 m-b"
  }, [_vm._v("LogBox Practice")]), _vm._v(" "), _c('p', {}, [_vm._v("Connecting Healthcare Professionals to their patients. Move your practice into the digital age. Join the LogBox community today.")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-default",
    attrs: {
      "to": "/practice"
    }
  }, [_vm._v("Learn More")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 grey-3"
  }, [_c('div', {
    staticClass: "p-a-lg"
  }, [_c('h3', {
    staticClass: "m-t-0 m-b"
  }, [_vm._v("LogBox Academic")]), _vm._v(" "), _c('p', {}, [_vm._v("A logbook and electronic portfolio for Academic Registrars, Supervisors and Heads of Departments.")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-default",
    attrs: {
      "to": "/academic"
    }
  }, [_vm._v("Learn More")])], 1)])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6d6d4fca"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/brochure/About.vue
// module id = 662
// module chunks = 5